<template>
  <div class="base">
    <inside-header title="收益记录" />
    <div class="list">
      <van-empty v-if="revenue_record.length === 0 && !loading" description="没有收益数据哦~" />
      <div v-for="(item, index) in revenue_record" :key="index" class="item">
        <div class="title">
          <span>{{ item.desc }}</span>
        </div>
        <div class="info clear">
          <div class="pull-left">
            <span class="" style="">{{ item.create_time | dayFormat }}</span>
            <span class="lode" style="">{{ item.create_time | minFormat }}</span>
          </div>
          <div class="pull-right">
            <span class="make" style="">+{{ item.profit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="last_page > 1" class="pagination">
      <van-pagination v-model="current_page" :total-items="total" :show-page-size="3" force-ellipses
        @change="pageChange" />
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'TeacherIncomeDetails',
  components: {
    InsideHeader
  },
  filters: {
    dayFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      //   var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      return m + '月' + d + '日'
    },
    minFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      var h = date.getHours()
      var m = date.getMinutes()
      return h + ':' + m
    }
  },
  data() {
    return {
      loading: false,
      revenue_record: [],
      current_page: 1,
      per_page: 10,
      last_page: 1,
      total: 0
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: 'index/teacher/incomeDetails',
        method: 'get'
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          var data = res.data
          console.log(data)
          this.revenue_record = data.revenue_record.data
          this.current_page = data.current_page
          this.last_page = data.last_page
          this.per_page = data.per_page
          this.total = data.total
          this.last_page = data.last_page
        }
      })
    },
    pageChange(value) {
      this.current_page = value
      this.$router.push({ name: 'UserPromoteWithdrawalRecord', query: this.filterCondition })
    }
  }
}
</script>
<style lang="stylus" scoped>

  .list {
    padding: 15px;

    .item {
      padding: 10px 0px;
      border-bottom: 1px solid #eee;

      .title {
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        line-height: 25px;
        color: #333333;
      }

      .info {
        .pull-left {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 28px;
          color: #999999;
        }

        .pull-right {
          font-family: PingFang-SC-Bold;
          font-size: 16px;
          line-height: 28px;
          color: #333333;
          font-weight: bold;
        }
      }
    }
  }
</style>
